import Router from 'next/router'
import { useApolloClient } from '@apollo/client/react'
import { logEvent, resetTracking } from 'lib/tracking/segment'
import { RouterPage } from 'lib/navigation/consts'
import { useNavatticTourStore } from 'routes/[businessId]/hooks/useNavatticTour/useNavatticTour'
import { clearChallenges } from 'routes/dialogs/MfaVerificationDialog/hooks/useVerificationChallenge/challengeStore'
import * as events from './useLogout.events'

export const useLogout = () => {
  const client = useApolloClient()
  const clearUntilLoginNavatticDismissals = useNavatticTourStore((store) => store.clearLoginDismissals)

  return () => {
    logEvent(events.SIGNED_OUT)
    resetTracking()
    // Login-scoped tour dismissals must not survive a re-login — the floating widget shows again next session.
    clearUntilLoginNavatticDismissals()
    // Same reason, and this one is signing out: the logout is a client-side push, so a challenge still
    // inside its send cooldown would otherwise be handed to whoever signs in next in this tab.
    clearChallenges()
    client.stop()
    client.clearStore()
    return Router.push(RouterPage.login)
  }
}
